import { NgModule } from "@angular/core";
import { CoreModule } from "../core/core.module";
import { OnfidoComponent } from "./components/onfido/onfido.component";
import { OnfidoClosePopupComponent } from "./components/close-modal/onfido-close-popup.component";
import { VerificationOnfidoFailedComponent } from "./components/verification-onfido-failed/verification-onfido-failed.component";
import { VerificationOnfidoContentComponent } from "./components/verification-onfido-content/verification-onfido-content.component";
import { VerificationTermsModalComponent } from "./components/verification-terms-modal/verification-terms-modal.component";
import { VerificationBrowserModalComponent } from "./components/verification-browser-modal/verification-browser-modal.component";

const components = [
	OnfidoComponent,
	OnfidoClosePopupComponent,
	VerificationOnfidoFailedComponent,
	VerificationOnfidoContentComponent,
	VerificationBrowserModalComponent,
	VerificationTermsModalComponent
];

@NgModule({
	imports: [CoreModule],
	declarations: [...components],
	exports: [...components]
})
export class OnfidoModule {}
